import axios from 'axios'

class ProductVariantGroupsConnector {
    /** @type{string} */
    _baseUrl

    /**
     * @param {string} middlewareUrl The url to the middleware used as base url for the endpoints.
     */
    constructor(middlewareUrl) {
        this._baseUrl = middlewareUrl + '/rest/product-variant-groups'
    }

    getProductVariantGroups = async () => {
        let url = this._baseUrl

        return axios.get(url)
        .then(response => response.data)
    }

    getProductVariantGroup = async (idProductVariantGroup) => {
        let url = this._baseUrl + '/' + idProductVariantGroup

        return axios.get(url)
        .then(response => response.data)
    }

    createProductVariantGroup = async (productVariantGroup) => {
        let url = this._baseUrl

        return axios.post(url, productVariantGroup)
        .then(response => response.data)
    }

    updateProductVariantGroup = async (idProductVariantGroup, productVariantGroup) => {
        let url = this._baseUrl + '/' + idProductVariantGroup

        return axios.put(url, productVariantGroup)
        .then(response => response.data)
    }

    changeProductVariantGroupSortOrder = async (sortedProductVariantGroupIds) => {
        let url = this._baseUrl
        url += '/sort-order'
        return axios.put(url, sortedProductVariantGroupIds)
        .then(response => response.data)
    }

    deleteProductVariantGroup = async (idProductVariantGroup) => {
        let url = this._baseUrl + '/' +idProductVariantGroup

        return axios.delete(url)
        .then(response => response.data)
    }
}

export default ProductVariantGroupsConnector